module.exports = __webpack_public_path__ + "static/media/madfit-2.43d37a27.jpg";